import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useFetch } from "../../../../../hooks/useFetch";
import { useRefreshProducers } from "../../../../../hooks/useRefreshStateHooks/useRefreshProducers";
import { useAppStore } from "../../../../../stores/RootStore";
import { Button } from "../../../../../ui/Button";
import { Input } from "../../../../../ui/Input/Input";
import { Label } from "../../../../../ui/Label/Label";
import { SelectButton } from "../../../../../ui/SelectButton/SelectButton";
import { useEquipmentModels } from "@/hooks/useFetchStateHooks/useEquipmentModels";

type Props = {
  id: string | undefined;
  refreshModels: Function;
};

const AddModel = ({ id, refreshModels }: Props) => {
  const equipmentTypesData = useAppStore((state) => state.equipmentTypes);
  const equipmentTypes = equipmentTypesData?.map((type) => {
    return { value: type.id, label: type.attributes.name };
  })!;

  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      name: "",
      equipment_type: { value: "", label: "" },
    },
  });

  const [{ response: modelSaveResponse, isLoading: modelSaveIsLoading, error: modelSaveError }, doFetchModelSave] =
    useFetch(`/directories/equipment_models?producer_id=${id}`);

  const onSubmit = (formData: any) => {
    doFetchModelSave({
      method: "POST",
      data: {
        data: {
          name: formData.name,
          producer_id: id,
          equipment_type_id: formData.equipment_type.value,
        },
      },
    });
  };

  const refreshAllModels = useEquipmentModels();
  const refreshAllProducers = useRefreshProducers();
  useEffect(() => {
    if (modelSaveResponse) {
      refreshModels();
      refreshAllModels();
      refreshAllProducers();
    }
  }, [modelSaveResponse]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-col w-full gap-1 bg-muted p-4 rounded">
        <div className="text-lg font-medium">{t("adding_model")}</div>
        <div className="text-sm">{t("adding_model_form_text")}</div>

        <div className="flex w-full items-end gap-4 mt-4">
          <div className="grid grid-cols-2 items-end w-full gap-4">
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("title_name")}*</Label>
                  <Input {...field} />
                </div>
              )}
            />

            <Controller
              name="equipment_type"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("equipment_type")}*</Label>
                  <SelectButton
                    label={"Выберите тип оборудования"}
                    searchable={true}
                    options={equipmentTypes}
                    value={value ? equipmentTypes.find((s) => s.value == String(value))! : null}
                    onChange={onChange}
                  />
                </div>
              )}
            />
          </div>

          <Button type="submit" size={"sm"}>
            {t("save")}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default AddModel;
